import { createApp } from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue, {BugsnagPluginVueResult} from '@bugsnag/plugin-vue'
import App from './App.vue'
import router from './router';
import './registerServiceWorker';
import { store, key } from "./store";

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* Global Componenets */
import AppHeader from "@/frame/AppHeader.vue";

Bugsnag.start({
    apiKey: 'a5d76b509a5d3acd7696c7ec0b835c8a',
    plugins: [new BugsnagPluginVue()]
})

const bugsnagVue = Bugsnag.getPlugin('vue')

const app = createApp(App)
    .use(bugsnagVue as BugsnagPluginVueResult)
    .use(IonicVue)
    .use(router)
    .use(store, key)
    .component('AppHeader', AppHeader)

router.isReady().then(() => {
    app.mount('#app');
});
